import { RegularShape } from 'ol/style';
import RRegularBase from './RRegularBase';
/**
 * A star or a regular polygon
 *
 * Requires an `RStyle` context
 *
 * Provides an `RStyle` context - for `Fill` or `Stroke`
 */
class RRegularShape extends RRegularBase {
    create(props) {
        this.classProps = RRegularShape.classProps;
        return new RegularShape(Object.assign(Object.assign({}, props), { stroke: this.stroke, fill: this.fill }));
    }
}
RRegularShape.classProps = RRegularBase.classProps.concat([
    'radius1',
    'radius2',
    'points',
    'angle'
]);
export default RRegularShape;
//# sourceMappingURL=RRegularShape.js.map